export default __webpack_public_path__ + "1a366268b593f6b0026e528a02e9c3ae.svg";